module.exports = __webpack_public_path__ + "img/media_2022_3.f8470641.jpg";